<template>
	<div class="depot_main">
		<div class="nav_cont">
			<div class="fh" @click="go_router"><i class="el-icon-arrow-left" style="margin-right: 12px;"></i>返回</div>
			<div class="fabu">{{goods_id > 0 ? '编辑商品信息' : '添加商品信息'}}</div>
		</div>
		<el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
		    <el-tab-pane class="tabTitle" label="商品属性" name="first">
				<div class="formtit" style="margin-top: 10px;">基础信息</div>
				<div class="form_param">
					<el-row>
						<el-col :span="24">
							
							<el-form :model="ruleForm" ref="ruleForm" label-position="left" label-width="120px" class="demo-ruleForm">
								
								<el-col :span="20" :offset="1">
									<el-form-item label="商品图片" prop="pro_img">
										<div class="up-group">
											<el-upload class="up-image" ref="upload_img" :file-list="coverArr"
												:headers="upload.headers" :action="upload.url" list-type="picture-card"
												:on-success="getCover" :multiple="false" :limit="1" :on-preview="previewCover"
												:before-upload="beforeAvatarUpload" :on-progress="onthecross"
												:on-remove="handleRemove" :class="{disUoloadSty:noneBtnImg}">
												<div class="up-div">
													<i class="el-icon-plus"></i>
												</div>
											</el-upload>
										</div>
									
										<p class="img_js">可上传1个商品图，建议图片尺寸700*700，图片最大不超过{{imgMaxSize}}M</p>
									</el-form-item>
								</el-col>
								
								<el-col :span="20" :offset="1">
									<el-form-item label="商品名称" prop="name">
										<el-input style="padding: 0;" type="text" placeholder="填写商品名称" v-model="ruleForm.name" maxlength="60"
											show-word-limit @input="changeInput($event,'name')">
										    <el-button v-if="goods_id == 0" slot="append" class="add_pro_btn" @click="chooseProduct()" style="padding: 11px 20px;">从商品库添加</el-button>
										</el-input>
									</el-form-item>
								</el-col>
								
								<el-col :span="24">
									<el-col :span="9" :offset="1">
										<el-form-item label="零售价" prop="retail_price">
											<el-input style="padding: 0;" type="text" placeholder="¥ 0.00" v-model="ruleForm.retail_price" maxlength="8"
											 @input="retailInput($event)">
											</el-input>
										</el-form-item>
									</el-col>
									
									<el-col :span="9" :offset="2">
										<el-form-item label="直播价" prop="tv_price" id="tv_price">
											<el-input style="padding: 0;" type="text" placeholder="¥ 0.00" v-model="ruleForm.tv_price" maxlength="8"
											 @input="tvInput($event)">
											</el-input>
										</el-form-item>
									</el-col>
								</el-col>
								
								<el-col :span="20" :offset="1">
									<el-form-item label="商品系列" prop="series" id="series">
										<el-input style="padding: 0;" type="text" placeholder="请填写商品所属系列" v-model="ruleForm.series" maxlength="50"
											show-word-limit @input="changeInput($event,'series')">
										</el-input>
									</el-form-item>
								</el-col>
								
								<el-col :span="20" :offset="1">
									<el-form-item label="商品分类" prop="series" id="series">
										<el-select v-model="ruleForm.index_id" placeholder="选择分类" style="width: 100%;" clearable>
										    <el-option
										      v-for="item in goods_category"
										      :key="item.id"
										      :label="item.name"
										      :value="item.id">
										    </el-option>
										  </el-select>
									</el-form-item>
								</el-col>
								
								<el-col :span="20" :offset="1">
									<el-form-item label="适用人群" prop="series" id="series">
										<el-select v-model="crowdArr" multiple placeholder="选择人群" style="width: 100%;">
										    <el-option
										      v-for="item in crowd"
										      :key="item.id"
										      :label="item.name"
										      :value="item.id">
										    </el-option>
										  </el-select>
									</el-form-item>
								</el-col>
								
								<el-col :span="20" :offset="1">
									<el-form-item label="使用场景" prop="scene" id="scene">
										<div class="depot-cate-view" @click="chooseScene()">
											<div class="depot-cate-val" v-if="scene_arr.length>0">已选{{scene_arr.length}}个</div>
											<div class="depot-cate-place" v-else>选择场景</div>
											<i class="el-icon-arrow-down depot-cate-right"></i>
										</div>
										
										<div style="margin-top: 20px;">
											<div v-for="(item,index) in scene_arr" style="width: fit-content;margin-right: 16px;float: left;">
											<el-tooltip effect="dark" placement="top">
												<template slot="content">
													<p style="max-width: 250px;">{{item.label}}</p>
												</template>
												<el-button type="info" class="scene_item">{{item.small_label}}
													<i class="el-icon-upload el-icon-close" @click="delScene(index)"></i>
												</el-button>
											</el-tooltip>
											</div>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="20" :offset="1">
									<el-form-item label="抖音短视频　　　　　带货信息" id="bring_goods">
										<table class="dy_table" border width="100%">
											<tr style="height: 60px;">
												<td width="15%" align="center" style="min-width: 85px;">店铺名称</td>
												<td width="85%" style="border-right: none;">
													<el-input style="padding: 0;" type="text" placeholder="请输入名称" v-model="ruleForm.dy_sales.name" maxlength="20"
													class="commerce" @input="changeInput($event,'shop_name')">
													</el-input>
												</td>
											</tr>
											<tr style="height: 60px;">
												<td width="15%" align="center" style="min-width: 85px;">商品口令</td>
												<td width="85%" style="border-right: none;">
													<el-input style="padding: 0;" type="text" placeholder="请输入商品口令" v-model="ruleForm.dy_sales.sale_pass" maxlength="200"
													class="commerce" @input="changeInput($event,'sale_pass')">
													</el-input>
												</td>
											</tr>
											<tr style="height: 60px;">
												<td width="15%" align="center" style="min-width: 85px;border-bottom: none;">商品链接</td>
												<td width="85%" style="border-bottom: none;border-right: none;">
													<el-input style="padding: 0;" type="text" placeholder="请输入商品链接" v-model="ruleForm.dy_sales.sale_url" 
													class="commerce" @input="changeInput($event,'sale_url')">
													</el-input>
												</td>
											</tr>
										</table>
									</el-form-item>
								</el-col>
								
								<el-col :span="20" :offset="1">
									<el-form-item label="商品属性" prop="" id="attr">
										<el-button type="primary" @click="addAttr()" class="add_btn">+添加属性</el-button>
										<div v-for="(item,index) in attr_arr" style="position: relative;">
											<el-input placeholder="请填写属性值" v-model="item.attr_val" maxlength="50" class="input-with-select" style="margin-top: 10px;">
												<el-input placeholder="请填写属性名称" v-model="item.attr_name" maxlength="15" slot="prepend" class="input-with-select">
												</el-input>
											</el-input>
											<i class="el-icon-error del_attr" @click="delAttr(index,item.id)"></i>
										</div>
									</el-form-item>
								</el-col>
								
								
								<el-col :span="20" :offset="1">
									<el-form-item label="核心卖点" prop="" id="merit">
										<el-button type="primary" @click="addMerit()" class="add_btn">+添加卖点</el-button>
										<div v-for="(item,index) in merit_arr" style="position: relative;">
											<div style="margin-top: 10px;">
											<el-input placeholder="请填写卖点" v-model="item.contents" maxlength="120">
												<template slot="prepend">产品卖点</template>
											</el-input>
											</div>
											<i class="el-icon-error del_attr" @click="delMerit(index,item.id)"></i>
										</div>
									</el-form-item>
								</el-col>
								
								<el-col :span="20" :offset="1">
									<el-form-item label="直播福利" prop="tv_reward" id="tv_reward">
										<el-input style="padding: 0;" type="textarea" placeholder="请填写商品直播福利" v-model="ruleForm.tv_reward" maxlength="120"
											show-word-limit rows="4" resize="none" @input="changeInput($event,'tv_reward')">
										</el-input>
									</el-form-item>
								</el-col>
							</el-form>
						</el-col>
					</el-row>
				</div>
			</el-tab-pane>
		    <el-tab-pane class="tabTitle" label="商品素材" name="second" v-loading="videoFlag">
				<div style="padding-left: 20px;">
					<el-dropdown>
					  <el-button type="primary" class="add_btn">
					    上传素材
					  </el-button>
					  <el-dropdown-menu slot="dropdown">
						<el-upload
						  ref="upload_img"
						  :headers="upload.headers"
						  :action="upload.url"
						  :on-success="getfile"
						  :multiple="true"
						  :before-upload="beforeAvatarUpload"
						  :on-progress="onthecross"
						  :show-file-list="false">
						  <el-dropdown-item>上传图片</el-dropdown-item>
						</el-upload>
					    
						<el-upload
						  action=""
						  :http-request="fnUploadRequest"
						  :show-file-list="false"
						  :before-upload="beforeUploadVideo">
						  <el-dropdown-item>上传视频</el-dropdown-item>
						</el-upload>
					    
					  </el-dropdown-menu>
					</el-dropdown>
					
					<el-dropdown>
					  <el-button type="primary" class="import_btn" style="margin-left: 22px;">
						素材库导入
					  </el-button>
					  <el-dropdown-menu slot="dropdown">
						<div @click="showMediaDialog(1)"><el-dropdown-item>导入图片</el-dropdown-item></div>
						<div @click="showMediaDialog(2)"><el-dropdown-item>导入视频</el-dropdown-item></div>
					  </el-dropdown-menu>
					</el-dropdown>
				</div>
				<div v-if="video_arr.length == 0 && pic_arr.length == 0" class="empty">
					<img src="../../assets/img/promotion/ztd_empty.png" />
					<div style="margin-top: 10px;">当前商品尚未有素材</div>
					<div>您可上传或素材库导入相关素材</div>
				</div>
				<div v-else>
					<div v-if="video_arr.length > 0">
						<div class="formtit" style="margin: 20px 0;">视频素材</div>
						<el-row :gutter="15" style="margin-left: 12px;">
						  <el-col :span="4" v-for="(item,index) in video_arr">
							  <div class="pic_item" :class="'pic_item_'+index" @mouseenter="enter('v_',index)" @mouseleave="leave('v_',index)">
							  	<el-image class="pic" :src="item.cover_url" fit="cover"></el-image>
								<img src="../../assets/img/goods/play.png" class="play-icon" @click="previewVideo(item.url)" />
								<el-row class="opt_btn" :id="'v_opt_btn_'+index">
									<el-col :span="8" style="text-align: center;">
										<i class="el-icon-search" @click="previewVideo(item.url)"></i>
									</el-col>
									<el-col :span="8" style="text-align: center;">
										<i class="el-icon-download" @click="download(item.id)"></i>
									</el-col>
									<el-col :span="8" style="text-align: center;">
										<i class="el-icon-delete" @click="delVideo(index)"></i>
									</el-col>
								</el-row>
							  </div>
						  </el-col>
						</el-row>
					</div>
					<div v-if="pic_arr.length > 0">
						<div class="formtit" style="margin: 20px 0;">图片素材</div>
						<el-row :gutter="15" style="margin-left: 12px;">
						  <el-col :span="4" v-for="(item,index) in pic_arr">
							  <div class="pic_item" @mouseenter="enter('p_',index)" @mouseleave="leave('p_',index)">
							  	<el-image class="pic" :src="item.cover_url" fit="cover"></el-image>
								<el-row class="opt_btn" :id="'p_opt_btn_'+index">
									<el-col :span="8" style="text-align: center;">
										<i class="el-icon-search" @click="previewImage(item.url)"></i>
									</el-col>
									<el-col :span="8" style="text-align: center;">
										<i class="el-icon-download" @click="download(item.id)"></i>
									</el-col>
									<el-col :span="8" style="text-align: center;">
										<i class="el-icon-delete" @click="delPic(index)"></i>
									</el-col>
								</el-row>
							  </div>
						  </el-col>
						</el-row>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<div style="height: 40px;"></div>
		<div class="save_btn">
			<el-button type="primary" @click="submitForm('ruleForm')" :disabled="is_submit_disabled">保存</el-button>
		</div>
		
		<choose-scene :show="showSceneChoose" :ids="scene_ids" @close="closeChooseScene" @success="successChooseScene"></choose-scene>
		
		<el-dialog width="540px" :visible.sync="showPreviewDialog"
			:before-close="closePreviewDialog">
			<template v-if="previewImageUrl">
				<img :src="previewImageUrl" style="width: 500px;height: 480px;object-fit: contain;"
					height="auto" />
			</template>
			<template v-else-if="previewVideoUrl">
				<video autoplay="autoplay" :src="previewVideoUrl"
					style="width: 500px;height: 480px;" controls="">您的浏览器不支持视频播放</video>
			</template>
		</el-dialog>
		
		<import-media :show="showImportMedia" :ids="media_arr" :type="media_dialog_type" @close="closeImportMedia" @success="successImportMedia"></import-media>
	
		<!-- 选择关联的商品 -->
		<choose-product :show="showChooseProduct" :connectPid="ruleForm.product_id" @close="closeChooseProduct" @success="successChooseProduct"></choose-product>
	</div>
	
</template>

<script>
	import {
		getGoodsIndexList,
	} from '@/api/depot_goods_index.js';
	import {
		saveGoods,
		getGoodsInfo
	} from '@/api/information';
	import{
		addMedia
	} from '@/api/depot_media';
	import {
		handleCode
	} from '@/utils/request';
	import oss from '@/utils/oss';
	import {
		baseURL,
		noPermissionCode
	} from '@/config';
	import chooseScene from '@/components/scene/choose.vue';
	import importMedia from '@/components/media/choose.vue';
	import chooseProduct from '@/components/product/choose-list.vue';
	
	export default{
		components: {
			chooseScene,
			importMedia,
			chooseProduct
		},
		data() {
			return{
				goods_category: [], // 商品分类
				crowd:[], // 适用人群数据
				crowdArr:'', // 已选试用人群
				coverArr:[], // 头图id、url
				noneBtnImg: false,
				activeName:'first', //默认选中的选项卡
				goods_id:0, //编辑传参
				is_submit_disabled:false, //保存按钮禁用状态
				is_submit:0,
				showSceneChoose:false, //是否展示选择场景弹框
				showImportMedia:false, //是否展示导入素材库弹框
				media_dialog_type:1, //素材弹框类型展示 1图片 2视频
				downloadurl:baseURL+"/Api/brand.NoAuth/downLoadMedia",
				ruleForm: {
					name: '', //商品名
					retail_price: '', //零售价格
					tv_price: '', //直播价格
					series: '', //商品系列
					dy_sales:{
						id:0, // 店铺id
						name:'', //店铺名称
						sale_pass:'', //商品口令
						sale_url:'', //商品链接
					},
					tv_reward:'', //直播福利
					index_id:'', // 商品分类索引id
					cover:0, // 头图id
					product_id:0, //关联商品id
				},
				scene_ids:[], //选择的场景id集合
				scene_arr:[], //场景
				del_attr_arr:[], //删除的商品属性id集合
				attr_arr:[], //商品属性
				video_arr:[], //视频素材集合
				pic_arr:[], //图片素材集合
				media_arr:[], //素材集合，根据media_dialog_type判断是图片还是视频
				del_merit_arr:[], //删除的卖点id集合
				merit_arr:[], //核心卖点
				
				showPreviewDialog:false,
				// ======= 视频上传
				videoFlag: false, //是否显示进度条
				previewVideoUrl: '',
				// =======
				// 照片墙
				imgMaxSize: 2, // 图片上传最大M
				previewImageUrl:'', 
				upload: {
					// 设置上传的请求头部
					headers: {
						authorization: this.$store.getters['user/accessToken'] ? this.$store.getters['user/accessToken'] :''
					},
					// 上传的地址
					url: baseURL + '/api/brand.Upload/oneToOss'
				},
				// === 选择关联商品 ====
				showChooseProduct: false,
			};
		},
		mounted() {
			var that = this;
			that.getGoodsIndexList(); // 获取分类、适用人群
			let query = this.$route.query;
			if (query.id > 0) {
				that.goods_id = query.id;
				
				that.getInfo();
			}
		},
		methods: {
			// 编辑获取商品信息
			getInfo(){
				var that = this;
				getGoodsInfo({
					goods_id: this.goods_id
				}).then(res => {
					if (res.code == 0) {
						that.ruleForm = res.data.baseData;
						that.scene_arr = res.data.sceneData;
						that.attr_arr = res.data.attrData;
						that.pic_arr = res.data.picArr;
						that.video_arr = res.data.videoArr;
						that.crowdArr = res.data.crowdArr;
						that.merit_arr = res.data.meritData;
						if(res.data.baseData.cover > 0){
							that.coverArr = [{file_id:res.data.baseData.cover,url:res.data.baseData.cover_url}];
							that.noneBtnImg = true;
						}
						if(res.data.baseData.index_id == 0){
							that.ruleForm.index_id = '';
						}
						
						delete(that.ruleForm.cover_url); // 删掉保存时不用的参数
					} else {
						this.$message.error(res.message);
					}
				})
			},
			// 保存表单
			submitForm(formName){
				const loading = this.$loading({
				  lock: true,
				  text: 'Loading',
				});
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.is_submit == 1) {
							return false;
						}
						this.is_submit = 1;
						
						// 必填项验证
						if (this.ruleForm.cover == 0) {
							this.$message.error("请上传商品头图");
							this.is_submit = 0;
				            loading.close();
							return false;
						}
						if (!this.ruleForm.name || this.ruleForm.name.length < 1) {
							this.$message.error("请输入商品名称");
							this.is_submit = 0;
				            loading.close();
							return false;
						}
						if (!this.ruleForm.retail_price.trim() || this.ruleForm.retail_price.length < 1) {
							this.$message.error("请输入零售价");
							this.is_submit = 0;
							loading.close();
							return false;
						}
						if ( this.ruleForm.retail_price <= 0) {
							this.$message.error("零售价设置不合理");
							this.is_submit = 0;
							loading.close();
							return false;
						}
						
						// 核心卖点
						var mer_count = 0
						this.merit_arr.forEach((item) => {
							if(mer_count > 0) return true;
							if(item.contents.trim().length > 0) mer_count++; 
						})
						if(mer_count == 0){
							this.$message.error("请填写核心卖点");
							this.is_submit = 0;
							loading.close();
							return false;
						}
						
						saveGoods({
							goods_id: this.goods_id,
							baseData: this.ruleForm,
							attrData: this.attr_arr,
							sceneData: this.scene_arr,
							picArr: this.pic_arr,
							videoArr: this.video_arr,
							delAttrData: this.del_attr_arr,
							crowdArr: this.crowdArr,
							meritData: this.merit_arr,
							delMeritData: this.del_merit_arr,
						}).then(res => {
							loading.close();
							if (res.code == 0) {
								this.$message.success(res.message);
								this.$router.go(-1);
							} else {
								this.is_submit = 0;
								this.$message.error(res.message);
							}
						})
					}else{
						loading.close();
						return false;
					}
				})
			},
			// 获取商品分类、试用人群
			getGoodsIndexList(){
				getGoodsIndexList({
					type: 1
				}).then(res => {
					if (res.code == 0) {
						this.goods_category = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
				getGoodsIndexList({
					type: 2
				}).then(res => {
					if (res.code == 0) {
						this.crowd = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
				
			},
			/**
			 * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
			 * @params {object} option [上传选项]
			 * @return {null} [没有返回]
			 */
			async fnUploadRequest(option) {
				// var videoDOM = document.getElementById("hidden_video");
				// if (videoDOM.duration > 60) {
				// 	this.$message.error("视频时长请限制在1分钟内");
				// 	this.videoFlag = false;
				// 	return false;
				// }
				oss.ossUploadFile(option).then((res) => {
					this.videoFlag = false;
					if (res.errcode === 0) {
						if (res.data.code == 0) {
							const vc_idx = res.data.data.video_cover_url.lastIndexOf("?");
							const cover_url = res.data.data.video_cover_url.substring(0,vc_idx);
							const v_idx = res.data.data.video_url.lastIndexOf("?");
							const video_url = res.data.data.video_url.substring(0,v_idx);
							
							addMedia({
								type: 2,
								cover_id:res.data.data.video_cover,
								cover_url: cover_url,
								file_id: res.data.data.video_id,
								file_url: video_url
							}).then(result => {
								if (result.code == 0) {
									var newVideo = {
										id: result.data,
										file_id: res.data.data.video_id,
										cover_file_id: res.data.data.video_cover,
										cover_url: res.data.data.video_cover_url,
										url: res.data.data.video_url
									}
									this.video_arr.push(newVideo);
								}
							})
						} else {
							this.$message.error("上传失败");
						}
					} else {
						this.$message.error(res.errmsg);
					}
				});
			},
			//视频上传前回调
			beforeUploadVideo(file) {
				var fileSize = file.size / 1024 / 1024 < 300;
				if (['video/mp4', 'video/3gp', 'video/m3u8', 'video/mov','application/x-mpegurl','audio/x-mpegurl','video/quicktime','video/3gpp'].indexOf(file.type) === -1) {
					this.$message.error("视频格式仅支持：mp4，3gp，m3u8，mov");
					return false;
				}
				if (!fileSize) {
					this.$message.error("视频大小不能超过300MB");
					return false;
				}
				this.videoFlag = true;
			},
			// 头图上传完成
			getCover(response, file, fileList){
				this.noneBtnImg = true;
				if (response.code == noPermissionCode) {
					handleCode(response.code, response.message);
				} else {
					var data = {
						file_id: response.data.id,
						url: response.data.url
					};
					this.coverArr.push(data);
					this.ruleForm.cover = response.data.id;
				}
				this.$refs.upload_img.clearFiles(); //上传成功之后清除历史记录
			},
			//上传完成
			getfile(response, file, fileList) {
				if (response.code == noPermissionCode) {
					handleCode(response.code, response.message);
				} else {
					// 上传完成加到素材库
					const index = response.data.url.lastIndexOf("?");
					const file_url = response.data.url.substring(0,index);
					
					addMedia({
						type: 1,
						cover_id:0,
						cover_url: '',
						file_id: response.data.id,
						file_url: file_url
					}).then(res => {
						if (res.code == 0) {
							var media_arr = {};
							media_arr = {
								id: res.data, // 素材id
								file_id: response.data.id,
								cover_url:response.data.url,
								url: response.data.url
							};
							this.pic_arr.push(media_arr);
							this.videoFlag = false;
						}
					})
				}
			},
			//图片上传前验证
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < this.imgMaxSize;
			
				if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
					this.$message.error('上传图片只能是 JPG、PNG、GIF 格式!');
					return false;
				}
			
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 '+this.imgMaxSize+'MB!');
					return false;
				}
				this.videoFlag = true;
				return isLt2M;
			},
			
			//删除图片
			handleRemove() {
				this.noneBtnImg = false;
				this.coverArr = [];
				this.ruleForm.cover = 0;
			},
			closePreviewDialog(done) {
				done();
				this.previewVideoUrl = '';
				this.previewImageUrl = '';
			},
			closeCateDialog(done){
				done();
			},
			// 预览视频
			previewVideo(url) {
				this.previewVideoUrl = url;
				this.showPreviewDialog = true;
			},
			// 预览图片
			previewImage(url) {
				this.previewImageUrl = url;
				this.showPreviewDialog = true;
			},
			// 预览头图
			previewCover(file) {
				this.previewImageUrl = file.url;
				this.showPreviewDialog = true;
			},
			// 文件上传时的钩子
			onthecross() {
				var circle = document.getElementsByClassName("el-progress-circle");

				if (circle[0]) {
					circle[0].style.width = "80px";
					circle[0].style.height = "80px";
				}
			},
			
			// 下载图片或视频
			download(id){
				var link = document.createElement("a");
				link.download = 'muban';
				link.href = this.downloadurl + '?media_id=' + id ;
				link.click();
				link.remove();
			},
			// 选择场景
			chooseScene(){
				this.scene_ids = [];
				for (const [key, value] of Object.entries(this.scene_arr)) {
				  this.scene_ids.push(value.id);
				}
				this.showSceneChoose = true;
			},
			// 删除场景
			delScene(idx){
				this.scene_arr.splice(idx,1);
			},
			// 关闭场景弹框
			closeChooseScene(){
				this.showSceneChoose = false;
			},
			// 场景选择完成
			successChooseScene(e){
				this.scene_arr = e;
				this.showSceneChoose = false;
			},
			// 添加属性
			addAttr(){
				var one = {id:0,attr_name:'',attr_val:''};
				this.attr_arr.push(one);
			},
			// 删除属性
			delAttr(idx,attr_id=0){
				this.attr_arr.splice(idx, 1);
				if(attr_id > 0){
					this.del_attr_arr.push(attr_id);
				}
			},
			// 添加卖点
			addMerit(){
				var one = {id:0,contents:''};
				this.merit_arr.push(one);
			},
			// 删除卖点
			delMerit(idx,merit_id=0){
				this.merit_arr.splice(idx, 1);
				if(merit_id > 0){
					this.del_merit_arr.push(merit_id);
				}
			},
			// 显示导入素材框
			showMediaDialog(type){
				this.media_dialog_type = type;
				this.media_arr = [];
				if(type == 1){
					for (const [key, value] of Object.entries(this.pic_arr)) {
					  this.media_arr.push(value.id);
					}
				}else{
					for (const [key, value] of Object.entries(this.video_arr)) {
					  this.media_arr.push(value.id);
					}
				}
				this.showImportMedia = true;
			},
			// 关闭导入素材框
			closeImportMedia(){
				this.showImportMedia = false;
			},
			// 导入素材成功
			successImportMedia(e){
				this.media_arr = e;
				if(this.media_dialog_type == 1){
					this.pic_arr = e;
				}else{
					this.video_arr = e;
				}
				this.showImportMedia = false;
			},
			
			//修改input值
			changeInput: function(event, type = 'name', index = 0) {
				var oldvalue = '' + event;
				let that = this;
				var value = oldvalue.replace(/\s/g, "");
				switch (type) {
					case "attr_name":
						that.attr_arr[index]['attr_name'] = oldvalue;
						break;
					case "attr_val":
						that.attr_arr[index]['attr_val'] = oldvalue;
						break;
					case 'name':
						that.ruleForm.name = value;
						break;
					case 'series':
						that.ruleForm.series = value;
						break;
					case 'shop_name':
						that.ruleForm.dy_sales.name = value;
						break;
					case 'sale_pass':
						that.ruleForm.dy_sales.sale_pass = value;
						break;
					case 'sale_url':
						that.ruleForm.dy_sales.sale_url = value;
						break;
					case 'tv_reward':
						that.ruleForm.tv_reward = value;
						break;
				}
			},
			// 鼠标移入图片时
			enter(prefix,index){
				var t = document.getElementById(prefix+'opt_btn_'+index);
				t.style.display="block"; // 设置显示元素
			},
			// 鼠标离开图片时
			leave(prefix,index){
				var t = document.getElementById(prefix+'opt_btn_'+index);
				t.style.display="none"; // 设置隐藏元素
			},
			// 删除视频
			delVideo(index){
				this.video_arr.splice(index,1);
			},
			// 删除图片
			delPic(index){
				this.pic_arr.splice(index,1);
			},
			// 零售价文本框输入事件
			retailInput(e){
				var retail = this.clearNoNum(e);
				this.ruleForm.retail_price = retail;
			},
			// 直播价文本框输入事件
			tvInput(e){
				var tv = this.clearNoNum(e);
				this.ruleForm.tv_price = tv;
			},
			// 文本框输入事件
			clearNoNum(obj){
			    obj = obj.replace(/[^\d.]/g,"");//清除"数字"和"."以外的字符    
			    obj = obj.replace(/^\./g,"");//验证第一个字符是数字而不是字符    
			    obj = obj.replace(/\.{2,}/g,".");//只保留第一个.清除多余的    
			    obj = obj.replace(".","$#$").replace(/\./g,"").replace("$#$",".");    
			    obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数
				return obj;
			},
			
			handleClick(tab, event) {
				console.log(tab, event);
			},
			go_router() {
				this.$router.go(-1)
			},
			// 选择关联商品
			chooseProduct(){
				this.showChooseProduct = true;
			},
			// 选择商品成功
			successChooseProduct(e){
				this.ruleForm.product_id = e.pid;
				this.ruleForm.cover = e.cover;
				this.ruleForm.name = e.name;
				this.ruleForm.retail_price = e.retail_price;
				
				if(e.cover > 0){
					this.coverArr = [{file_id:e.cover,url:e.cover_url}];
					this.noneBtnImg = true;
				}
				
				this.showChooseProduct = false;
			},
			// 关闭弹框
			closeChooseProduct(){
				this.showChooseProduct = false;
			}
		}
	}
</script>

<style scoped>
	.father-main {
		overflow: auto;
	}

	.depot_main {
		background: #ffffff;
	}

	@keyframes bganimation {
		0% {
			background-position: 0% 50%;
		}

		50% {
			background-position: 100% 50%;
		}

		0% {
			background-position: 0% 50%;
		}
	}

	.depot_main .nav_cont {
		width: 100%;
		height: 60px;
		border-radius: 4px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #EEEEEE;
		margin-bottom: 15px;
	}

	.formtit {
		width: 100px;
		height: 25px;
		border-left: 3px solid #409EFF;
		line-height: 25px;
		padding-left: 15px;
		margin-bottom: 23px;
	}

	.fh {
		width: 92px;
		height: 23px;
		text-align: center;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 23px;
		border-right: 1px solid #CCCCCC;
		margin-right: 21px;
		cursor: pointer;
	}

	.fabu {
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}
	.depot_main .el-tabs--border-card{
		border: none;
		box-shadow:none;
	}
	.depot_main >>> .el-tabs__item{
		height: 36px;
		border-radius: 4px;
		color: #303133;
		font-weight: bold;
	}
	.depot_main >>> .el-tabs__item:not(.is-disabled):hover{
		color: #303133;
	}
	.depot_main >>> .el-tabs__header{
		height: 36px;
		margin: 0 20px;
		border: 1px solid #F0F2F5;
		border-right: none;
		background: #F0F2F5;
		border-radius: 4px;
	}
	.depot_main >>> .el-tabs--border-card>.el-tabs__header .is-active{
		border: none;
		color: #1989FA;
	}
	.depot_main >>> .el-tabs--border-card>.el-tabs__content{
		padding: 20px 20px 20px 2px;
	}
	.depot_main >>> .el-textarea .el-input__count,
	.depot_main >>> .el-input .el-input__count {
		color: #666666;
	}
	.depot_main >>> .el-textarea .el-input__count{
		bottom: -10px;
		right: -48px;
	}
	.depot_main .el-input >>> .el-input__suffix{
		top: 12px;
		right: -48px;
	}
	.depot_main .el-select >>> .el-input__suffix{
		right: 5px;
	}
	.depot_main >>> .el-select__caret{
		color: #333333;
	}
	.form_param >>> .el-form-item__label::before {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
	}
	#tv_price >>> .el-form-item__label::before,
	#tv_reward >>> .el-form-item__label::before,
	#attr >>> .el-form-item__label::before,
	#scene >>> .el-form-item__label::before,
	#series >>> .el-form-item__label::before{
		content: '';
		margin-left: 6px;
	}
	#bring_goods >>> .el-form-item__label::before{
		content: '';
		margin-left: 0;
		margin-right: 0;
	}
	.commerce >>> .el-input__inner{
		height: 60px;
		line-height: 60px;
		border: none;
	}
	.dy_table{
		border: 1px solid #DCDFE6;
		border-spacing: 0;
	}
	.dy_table >>> tr {
		border-bottom: 1px solid #EEEEEE;
		border-left: none;
		border-right: none;
	}
	
	.dy_table >>> td {
		border-right: 1px solid #EEEEEE;
		border-top: none;
		border-left: none;
	}
	#attr >>> .el-input-group__prepend{
		border: none;
		background: none;
		padding: 0;
		width: 20%;
		min-width: 157px;
	}
	#attr >>> .el-input-group__prepend .el-input__inner{
		border-right: none;
		border-radius: 4px 0 0 4px;
	}
	.depot_main >>> .add_btn{
		color: #409EFF;
		background: #ecf5ff;
		border-color: #b3d8ff;
	}
	.depot_main >>> .import_btn{
		background-color: #ffffff;
		border: 1px solid #DCDFE6;
		color: #666666;
	}
	#attr >>> .del_attr{
		font-size: 18px;
		color: #999999;
		position: absolute;
		right: -25px;
		bottom: 10px;
		cursor: pointer;
	}
	.save_btn{
		position: fixed;
		bottom: 0;
		background: #F5F5F5;
		width: calc(100% - 309px);
		height: 70px;
		text-align: center;
	}
	.save_btn >>> button{
		margin-top: 15px;
	}
	
	.depot-cate-view{
		display: flex;
		align-items: center;
		height: 40px;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
	}
	.depot-cate-place{
		font-size: 14px;
		font-weight: 500;
		color: #AAAAAA;
		line-height: 14px;
		margin-left: 10px;
	}
	.depot-cate-val{
		font-size: 14px;
		font-weight: 500;
		color: #333333;
		line-height: 14px;
		margin-left: 10px;
	}
	.depot-cate-right{
		margin-left: auto;
		margin-right: 10px;
	}
	.scene_item{
		height: 32px;
		line-height: 32px;
		font-size: 14px;
		color: #606266;
		padding: 0 13px;
		background-color: #F5F5F5;
		border: none;
		border-radius: 4px;
	}
	.scene_item i{
		margin-left: 8px;
	}
	.empty {
		width: 100%;
		height: 500px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}
	.empty img {
		width: 126px;
		height: 140px;
	}
	.empty div {
		font-size: 12px;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}
	.pic_blo{
		padding: 0 20px;
	}
	.pic_item{
		position:relative;
		width:100%;
		height:0;
		padding-top:100%;
		margin-bottom: 20px;
	}
	.pic{
		position:absolute;
		top:0;
		left:0;
		width:100%;
		height:100%;
		border-radius: 4px;
	}
	.play-icon{
		width: 35%;
		height: 35%;
		position: absolute;
		left: calc(65% / 2);
		top: calc(65% / 2);
	}
	.opt_btn{
		width: 100%;
		height: 28px;
		padding: 3px 10px;
		position:absolute;
		bottom:-20px;
		background: rgba(0,0,0,0.5);
		border-radius: 0px 0px 4px 4px;
		color: #ffffff;
		font-size: 16px;
		display: none;
	}
	.opt_btn i{
		cursor: pointer;
	}
	
	.el-row {
	    margin-bottom: 20px;
	    &:last-child {
	      margin-bottom: 0;
	    }
	}
	
	.up-group {
		display: flex;
	}
	
	.up-image {
		position: relative;
		margin-right: 15px;
	}
	.player-div {
		width: 90px;
		height: 90px;
		object-fit: cover;
		border-radius: 4px;
	}
	.form_param >>> .el-upload--picture-card {
		width: 90px;
		height: 90px;
		line-height: 90px;
		border: 0;
		margin: 0 8px 8px 0;
	}
	
	.disUoloadSty >>> .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.play-icon {
		width: 35px;
		height: 32px;
		position: absolute;
		left: calc((100% - 35px) / 2);
		top: calc((100% - 32px) / 2);
	}

	.i_upload-video {
		width: 100%;
		height: 100%;
	}

	.up-div {
		width: 90px;
		height: 90px;
		background: #F2F6FC;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
	}

	.up-div .el-icon-plus {
		color: #429FFF;
		font-size: 35px;
		font-weight: bold;
	}
	
	.img_js {
		font-size: 12px;
		font-weight: 500;
		color: #999999;
	}
	
	.depot_main >>> .el-upload-list__item{
		width: 90px;
		height: 90px;
	}
	.depot_main >>> .el-form-item__content{
		line-height: unset;
	}
	.depot_main >>> .el-upload-list__item.is-success .el-upload-list__item-status-label {
		display: none;
	}
	
	
	
	
	#merit >>> .el-input-group__prepend{
		width: 20%;
		min-width: 157px;
		box-sizing: border-box;
	}
	#merit >>> .el-input-group__prepend .el-input__inner{
		border-right: none;
		border-radius: 4px 0 0 4px;
	}
	#merit >>> .del_attr{
		font-size: 18px;
		color: #999999;
		position: absolute;
		right: -25px;
		bottom: 10px;
		cursor: pointer;
	}
	.add_pro_btn{
		color: #1989FA !important;
		width: 134px;
		font-size: 14px;
		background-color: #ffffff !important;
	}
</style>